import styled from 'styled-components'

import Box from 'app/components/design-system-components/Box'
import theme from 'app/match/applicationReportPDF/assets/theme'

const DEFAULT_RADIUS = '10px'

export const TextSeparatorDot = styled(Box)`
  display: inline-block;
  border: 3px solid
    ${({ borderColor }) =>
      borderColor ? borderColor : theme.colors.transparent};
  border-radius: 100%;
  position: relative;
  width: ${({ radius }) => (radius ? radius : DEFAULT_RADIUS)};
  height: ${({ radius }) => (radius ? radius : DEFAULT_RADIUS)};
  background: ${({ bgColor }) => bgColor};
`
